
import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  TableContainer,
  Grid,
  TableFooter,
} from '@mui/material';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import SalesLinesModal from './saleslinemodal';
import { useStyle } from '../style';
import moment from 'moment';

const DetailsModal = ({ open, onClose, data,salesLines }) => {
  const [isSalesLinesModalOpen, setIsSalesLinesModalOpen] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedSalesLines, setSelectedSalesLines] = useState(null);
  const classes = useStyle();
  if (!data) return null;
console.log(data,"datadatadatadata");


console.log(salesLines?.outletSales_lines,"salesLines423553");
const salesdata = data?.outletSales_lines;
console.log(salesdata,"salesdata");
  // const handleViewClick = () => {
  //   setIsSalesLinesModalOpen(true);
  // };
  const handleViewClick = (salesLines) => {
    setSelectedSalesLines(salesLines);
    setIsSalesLinesModalOpen(true);
  };
  const handleSalesLinesModalClose = () => {
    setIsSalesLinesModalOpen(false);
    setSelectedSalesLines(null);
  };


  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            backgroundColor: '#fff',
            padding: 2,
            maxWidth: 1200,
            margin: 'auto',
            marginTop: '10%',
            borderRadius: 1,
            boxShadow: 24,
          }}
        >
          <div className="flex justify-end">
            {/* {data && (
              <Grid className="my-1">
                <Typography sx={{ marginBlock: 0.5 }}>
                  Bill No : <strong>{data.docno}</strong>
                </Typography>
                <Typography>
                  Bill Date : <strong>{ moment(data.docdate).format("DD-MM-YYYY") }</strong>
                </Typography>
              </Grid>
            )} */}
            {/* <div className="flex my-1" style={{ flexDirection: 'column' }}>
              <Typography>
                Sales Man : <strong>{data.sales_man_name}</strong> -{' '}
                <strong>{data.sales_man_code}</strong>
              </Typography>
              <Typography>
                Payment Mode : <strong>{data.mode}</strong>
              </Typography>
            </div> */}
            <IconButton size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <TableContainer className={classes.tblRoot} sx={{width: '100%',maxHeight: 400, overflow:"auto"}} >
        <Table stickyHeader  className={classes.table} sx={{ maxHeight: 350, overflowY: 'auto'  }}>
          <TableHead className={classes.tblHeader}>
            <TableRow className={classes.tablrow}>
              {/* <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell> */}
              
              <TableCell className={classes.tblCell}>Name</TableCell>
              <TableCell className={classes.tblCell}>Mobile</TableCell>
              <TableCell className={classes.tblCell}>Address</TableCell>
              <TableCell className={classes.tblCell}>Bill No</TableCell>
              <TableCell className={classes.tblCell}>Bill Date</TableCell>
              <TableCell className={classes.tblCell}>Time</TableCell>
              <TableCell className={classes.tblCell}>Sales Man</TableCell>
              <TableCell className={classes.tblCell}>Payment Mode</TableCell>
              <TableCell className={classes.tblCell}>GST%</TableCell>
              <TableCell className={classes.tblCell}>GST Amt</TableCell>
              <TableCell className={classes.tblCell}>Dis%</TableCell>
              <TableCell className={classes.tblCell}>Cess%</TableCell>
              <TableCell className={classes.tblCell}>Cess Amt</TableCell>
              <TableCell className={classes.tblCell}>Amount</TableCell>
              <TableCell className={classes.tblCell}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
         
         {data.map((data)=>(      
          <TableRow className={classes.tablrow} key={data.id}>
     

              <TableCell>{data.party_name}</TableCell>
               <TableCell variant="body" className={classes.tblContentCell}>{data.mobile}</TableCell>
               <TableCell>{data.address}</TableCell>
               <TableCell>{data.docno}</TableCell>
               <TableCell>{ moment(data.docdate).format("DD-MM-YYYY") }</TableCell>
               {/* <TableCell>{ moment(data.docdate).format("hh:mm A") }</TableCell> */}
               <TableCell>{ moment(data.created_at).format("hh:mm A") }</TableCell>
           
               <TableCell>{data.sales_man_name}</TableCell>
               <TableCell>{data.mode}</TableCell>
               <TableCell>{data.gst_per}</TableCell>
               <TableCell>{parseFloat(data.gst_amt).toFixed(0)}</TableCell>
        
               <TableCell>{parseFloat(data.discount_amount).toFixed(0)}</TableCell>
               <TableCell>{data.cess_per}</TableCell>
               <TableCell>{data.cess_amt}</TableCell>
               <TableCell>{data.amount}</TableCell>
               <TableCell>
               <IconButton
          size="small"
          onClick={() => handleViewClick(data.outletSales_lines)}
          // onClick={handleViewClick}
        >
          <VisibilityIcon sx={{ fontSize: 18 }} />
        </IconButton>
        </TableCell>
             </TableRow>))}
       
          

          </TableBody>
          {/* <TableFooter>
                <TableRow>
                  <TableCell colSpan={8} />
                  <TableCell className={classes.tblCell}>
                    <strong>Total Amount:</strong>
                  </TableCell>
                  <TableCell className={classes.tblCell}>
                  <strong>{totalAmount}</strong>                  </TableCell>
                </TableRow>
              </TableFooter> */}
        </Table>
          
      </TableContainer>
       
        </Box>
      </Modal>
      {/* <SalesLinesModal
        open={isSalesLinesModalOpen}
        onClose={handleSalesLinesModalClose}
        // salesLines={salesLines}
        salesLines={data.outletSales_lines}
      /> */}
       {selectedSalesLines && (
        <SalesLinesModal
          open={isSalesLinesModalOpen}
          onClose={handleSalesLinesModalClose}
          salesLines={selectedSalesLines}
        />
      )}
    </>
  );
};

export default DetailsModal;
